import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, FormGroup, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';

export const NOOP_VALUE_ACCESSOR: ControlValueAccessor = {
  writeValue(): void {},
  registerOnChange(): void {},
  registerOnTouched(): void {},
};

@Component({
  selector: 'app-select-all',
  templateUrl: './select-all.component.html',
  styleUrls: ['./select-all.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectAllComponent implements ControlValueAccessor {
  @Input() label;
  @Output() deleted = new EventEmitter();
  @Output() selectedAll = new EventEmitter<boolean>();

  get control(): UntypedFormControl {
    return this.ngControl.control as UntypedFormControl;
  }

  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = NOOP_VALUE_ACCESSOR;
    }
  }

  handleSelectAll(event: Event): void {
    this.selectedAll.emit((event.target as HTMLInputElement).checked);
  }

  registerOnChange(fn: any): void {}

  registerOnTouched(fn: any): void {}

  writeValue(obj: any): void {}
}
